import { atom } from 'jotai'
import { createContext, type ReactNode } from 'react'
import {
  type Message,
  type RefType,
} from 'src/services/apollo/generated/graphql'
import { throwError } from 'src/utils/error'

export type CanDeleteMessage = (message: Message) => boolean | undefined
export type DeleteMessage = (id: string, refType?: RefType) => Promise<void>
export type SendMessage = (content: string, replyTo?: string) => Promise<void>

export const DEFAULT_LOAD_SIZE = import.meta.env.DEV ? 5 : 30

export const createComposerStateAtom = () =>
  atom({
    replyTo: undefined as string | undefined,
  })
export type ComposerStateAtom = ReturnType<typeof createComposerStateAtom>

export type CommentContextValue = {
  refType?: RefType
  /** Badges comments from this user as "Creator". */
  creatorId?: string
  /** From the topic fragment (e.g., `artwork.commentCount`). */
  totalCount?: number
  // Message list
  messages: Message[]
  messageCache: Map<string, Message>
  havingMore: boolean
  everHadMore: boolean
  loadMore: (pageSize?: number) => void
  loading: boolean
  // Message item
  canDeleteMessage?: CanDeleteMessage
  deleteMessage: DeleteMessage
  // Composer
  composerStateAtom: ComposerStateAtom
  sendMessage: SendMessage
  // Turnstile
  TurnstileWidget: () => ReactNode
  turnstileReady: boolean
}

export const CommentContext = createContext<CommentContextValue | undefined>(
  undefined,
)

export function ensureContext(): never {
  throwError('This component should be within a <CommentProvider>')
}
